import React, { Component }  from 'react';
import '../../style.css';
import {Button, Card, message, Modal, PageHeader, Space, Table} from "antd";
import {fetchPost, fetchPostFile} from "../../static/util/fetch";
import FileViewer from 'react-file-viewer';
const { Column } = Table;
//江苏及山东其他地区
class IPSummaryTable extends Component {
    constructor(props) {
        super(props);
        this.state={
            IPAuthorized:[],
            companyName:this.props.companyName,
            companyId:this.props.companyId,
            fileStream:'',
            preview_visible:false,
            loading:false,
        }
        this.hideModal = this.hideModal.bind(this);
    }
   componentDidMount() {
       this.setState(()=>({
           loading:true
       }))
       fetchPost(global.constants.getPatentAuthorized,{companyName: this.state.companyName})
           .then(
               res => {
                   if(res.code === 200) {
                       this.setState(()=>({
                           IPAuthorized:res.data,
                           loading:false
                       }))
                   }
                   else{
                       this.setState(()=>({
                           loading:false
                       }))
                      message.info("没有知识产权，请先添加知识产权！").then()
                   }
               }
           )
   }
    hideModal(){
        this.setState(()=>({
            preview_visible:false,
        }))
    }
    handlePreviewClick(){
        let params={
            companyId:this.state.companyId,
            fileName:'2-3知识产权情况汇总表.doc'
        }
        fetchPost(global.constants.checkFileProcess, params)
            .then(
                res=> {
                    if (res.code === 200) {
                        let params = {
                            companyId:this.state.companyId,
                            projectId:0,
                            productId:0,
                            patentId:0,
                            otherId:0,
                            remark:'',
                            url: '/create/'+this.state.companyName+'/知识产权情况汇总表.pdf',
                            fileName: '知识产权情况汇总表.pdf'
                        }
                        fetchPostFile(global.constants.previewFile,params)
                            .then(
                                res=>{
                                    res.blob().then(
                                        blob=> {
                                            let blobUrl = window.URL.createObjectURL(blob);
                                            this.setState(()=>({
                                                fileStream:blobUrl,
                                                preview_visible:true,
                                            }))
                                        })
                                }
                            )
                    }else{
                        message.info("云端不存在该文件，请先生成！").then()
                    }
                }
            )
    }
    handleExportClick(){
        fetchPost(global.constants.exportTemplateC,{companyId:this.state.companyId})
            .then(
                res=>{
                    if(res.code === 200) {
                        message.success("已在云端生成，请下载").then()
                    }
                }
            )
    }
    download(){
        let params = {
            companyId:this.state.companyId,
            projectId:0,
            productId:0,
            patentId:0,
            otherId:0,
            remark:'',
            url: '/create/'+this.state.companyName+'/2-3知识产权情况汇总表.doc',
            fileName: '知识产权情况汇总表.doc'
        }
        fetchPostFile(global.constants.downloadFile,params)
            .then(
                response=>{
                    response.blob().then(
                        blob=>{
                            let blobUrl = window.URL.createObjectURL(blob);
                            let aElement = document.getElementById('downloadDiv'); //获取a标签元素
                            let filename = '2-3知识产权情况汇总表.doc';//设置文件名称
                            aElement.href = blobUrl;//设置a标签路径
                            aElement.download = filename;
                            aElement.click();
                            window.URL.revokeObjectURL(blobUrl);
                        }
                    )
                }
            )
    }
    render(){
        const Anchor = props => {
            return (
                <a {...props}>{props.children}</a>
            );
        };
        return(
            <div>
                <Anchor id="downloadDiv" style={{display: 'none'}}/>
                <div className="content-page-header">
                    <PageHeader
                        ghost={false}
                        title="知识产权情况汇总表"
                        subTitle="江苏及山东其他地区"
                        extra={[
                            <Button
                                onClick={this.handleExportClick.bind(this)}>生成</Button>,
                            <Button
                                type="primary"
                                onClick={this.handlePreviewClick.bind(this)}
                            >预览</Button>,
                        ]}
                    >
                    </PageHeader>
                </div>
                <Space direction="vertical" className="content-style" >
                    <Card bordered={true} style={{border:'solid  1px #7F9DB9'}} >
                        <Table dataSource={this.state.IPAuthorized} loading={this.state.loading}>
                            <Column align="center" title={<p className="list-column-style">序号</p>} width="80" render={(text,record,index)=>`${index+1}`}/>
                            <Column align="center" title={<p className="list-column-style">企业名称</p>} dataIndex="companyName" key="companyName" render={()=><li>{this.state.companyName}</li>}/>
                            <Column align="center" title={<p className="list-column-style">知识产权名称</p>} dataIndex="patentName" key="patentName" />
                            <Column align="center" title={<p className="list-column-style">种类</p>} dataIndex="type" key="type" />
                            <Column align="center" title={<p className="list-column-style">类别</p>} dataIndex="category" key="category" />
                            <Column align="center" title={<p className="list-column-style">授权号</p>} dataIndex="authorizationNumber" key="authorizationNumber" />
                            <Column align="center" title={<p className="list-column-style">授权日期</p>} dataIndex="authorizationTime" key="authorizationTime" />
                            <Column align="center" title={<p className="list-column-style">权利人</p>} dataIndex="companyName" key="companyName" render={()=><li>{this.state.companyName}</li>}/>
                            <Column align="center" title={<p className="list-column-style">获得方式</p>} dataIndex="access" key="access"/>
                            <Column align="center" title={<p className="list-column-style">与网上法律状态</p>} dataIndex="legalStatus" key="legalStatus" />
                            <Column align="center" title={<p className="list-column-style">历史申请认定是否使用过该专利</p>} dataIndex="history" key="history" />
                        </Table>
                    </Card>
                </Space>
                <Modal
                    visible={this.state.preview_visible}
                    title={'预览'}
                    onCancel={this.hideModal}
                    destroyOnClose
                    width={'70%'}
                    footer={[
                        <Button key="back" onClick={this.hideModal}>
                            取消
                        </Button>,
                        <Button key="back"  type="primary" onClick={this.download.bind(this)}>
                            下载
                        </Button>,
                    ]}
                >
                    <FileViewer fileType='pdf'
                                filePath={this.state.fileStream}
                                onError={this.onError}
                    />
                </Modal>
            </div>
        )
    }
}
export default IPSummaryTable;